module.exports = __webpack_public_path__ + "static/media/karriere.dc045145.jpg";